import { VStack, Heading } from '@chakra-ui/react';
import { LoginForm } from 'domains/login';
import { getIdentityLayout } from 'layouts';
import { getUser, redirectLoggedInUser } from 'lib/server-side';
import { CustomNextPage, RoleLevels } from 'lib/types';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const user = await getUser(ctx);

  if (user) {
    return redirectLoggedInUser(ctx, user);
  }

  return { props: {} };
}

const Login: CustomNextPage = () => (
  <VStack spacing={10}>
    <Heading variant="auth-title" size="lg">
      Sign into your Packs account
    </Heading>
    <LoginForm />
  </VStack>
);

Login.getLayout = getIdentityLayout;
Login.allowedRoles = [ RoleLevels.OPEN ];

export default Login;
